<template>
  <v-container class="grey lighten-5">
    <v-row justify="center">
      <v-col cols="10">
        <v-card
          class="pa-5"
          outlined
          tile>
          <v-row>
           <v-text-field class='col-8' 
            v-model='keyword'
            label="Search Patient"
            single-line
            solo
            required
            @keyup.enter.native="onSubmit"
          ></v-text-field>
          <v-select  class='pl-5 col-4'
          :items="searchItems"
          item-text="name"
          item-value="value"
          v-model='searchCriteria'
          required
          solo
        ></v-select>
          </v-row>
        <label>Search History: </label>
    <v-chip @click='setKeyword(item)' :key='index' v-for='(item,index) in history'>
      {{item}}
    </v-chip>
        </v-card>
        
      </v-col>
       <v-col class='col-10'>
        <v-card
          class="pa-2"
          outlined
          tile>
           <v-card-title>
      Patients Data
      <div class="flex-grow-1"></div>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
        :loading='tableLoader'
        loading-text="Fetching data.... please wait"
      :headers="headers"
      :items="data"
      :search="search"
    >
    <template v-slot:item.action="{ item }">
       <v-icon
        small
        class="mr-2"
       @click='$router.push("/user/email/"+item.info.email)'
      >
        edit
      </v-icon>
    </template>
  
    <template v-slot:item.lastUpdateInUtc="{ item }">

     {{item.lastUpdateInUtc ? $momentTz.tz(item.lastUpdateInUtc,'America/Los_Angeles').format("MM-DD-YYYY HH:mm:ss") : ""}}
    </template>


    </v-data-table>
           
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {postReq} from '../helper/firestore'
import { mapFields } from 'vuex-map-fields';

export default {
    computed: {
    ...mapFields([
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ])
    },
    data() {
        return {
            history : null,
            dialog: false,
            tableLoader : true,
            search: '',
            data : [],
            headers: [
          {
            text: 'Email',
            value: 'info.email',
          },
          { text: 'Name', value: 'info.name' },
          { text: 'Assigned GC', value: 'assignedGC.email' },
          { text: 'Phone #', value: 'info.phone' },
          { text: 'Last Update', value: 'lastUpdateInUtc'},
           { text: 'Actions', value: 'action', sortable: false },
        ],
            searchItems : [
                {name :"Email", value : "info.email"}, 
                {name : "First Name + Last Name", value:"info.name"},
                {name : "Phone number", value:"info.phone"},
                {name : "EHR number", value : "info.recordNum"}],
            searchCriteria : "info.email",
            keyword : null
        }
    },
    mounted(){
           this.fetchHistory()
           this.fetchAllPatient()
    },
    methods : {
      fetchAllPatient(){
            postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/patients/getallPatients', {uid : this.user.uid}, result => { 
            this.data = result.data;
            this.tableLoader = false ;
            })
      },
      setKeyword(){
        this.onSubmit()
      },
        fetchHistory(){
          postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/log/getLog', { type : "patient search",uid : this.user.uid}, result => { 
            let tempHistory = result.data.map(history => history.description.keyword)
            this.history = [...new Set(tempHistory)];
            })
        },
         onSubmit(){
            this.keyword = this.keyword.trim();
             this.fetchPatient();
         },
        fetchPatient(){
            this.tableLoader = true
            postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/patients/getPatients', { uid: this.user.uid, searchCriteria: this.searchCriteria, keyword : this.keyword }, result => { 
                this.data = result.data
                this.tableLoader = false  
            })
        },
        editItem (item) {
        this.editedIndex = this.data.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.data.indexOf(item)
        confirm('Are you sure you want to delete this patient?') && this.data.splice(index, 1)
      },
    }

}
</script>

<style>

</style>
